import Component from '../core/Component'
import debounce from 'lodash/debounce'
import Flickity from 'flickity'

export const EMITS = {
    LINK_CLICKED: 'linkClicked'
}

export default class Menu extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            links: []
        }

        this.lastIndex = null
        this.flickity = null
        this.handleResizeEnd = () => this.check()
        this.resizeEnd = debounce(this.handleResizeEnd, 200)
    }

    prepare() {
        this.ref.links.forEach(link => link.addEventListener('click', this.handleLinkClick))

        window.addEventListener('resize', this.handleResize)
        this.check()
    }

    destroy() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize = () => {
        this.resize()
    }


    handleLinkClick = event => {
        event.preventDefault() //@TODO: doresit propisovani hashe a historii swupu
        const element = event.currentTarget
        const index = this.ref.links.indexOf(element)

        this.emit(EMITS.LINK_CLICKED, {
            index
        })
    }

    resize() {
        this.destroyFlickity()
        this.resizeEnd()
    }

    check() {
        if (this.flickity) {
            return
        }

        if (this.element.offsetWidth < this.element.scrollWidth) {
            this.flickity = new Flickity(this.element, {
                cellAlign: 'center',
                prevNextButtons: false,
                pageDots: false,
                contain: true
            })
        }

        if (this.lastIndex) {
            this.select(this.lastIndex)
        }
    }

    destroyFlickity() {
        if (!this.flickity) {
            return
        }
        this.ref.fcktySlider = null
        this.flickity.destroy()
        this.flickity = null
    }

    getLinks() {
        return this.ref.links
    }

    getActiveLinkIndex() {
        return this.ref.links.findIndex(link => link.classList.contains('is-active'))
    }

    select(index) {
        this.ref.links.forEach(link => link.classList.remove('is-active'))
        this.ref.links[index].classList.add('is-active')

        this.flickity?.select(index)
    }
}